var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconReportInappropriateVisuals = function SvgIconReportInappropriateVisuals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B6C3D6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.545 8.64a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.845 8.295c-.713 1.05-3.034 3.946-6.965 3.946S1.63 9.344.916 8.294a.66.66 0 0 1 0-.748C1.63 6.496 3.95 3.6 7.88 3.6s6.252 2.896 6.965 3.946a.66.66 0 0 1 0 .748m-3.46-.375a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0",
    clipRule: "evenodd"
  }))));
};
export default SvgIconReportInappropriateVisuals;